import React, { Component } from "react";
import {Row, Col, Button, Table} from 'react-bootstrap'
// import { connect } from 'react-redux';
// import {WebFormTemplateNames, WebFormViewReport, WebFormViewReportSubmit, closeModalPopUp} from './WebFormAction';
// import ShowModalPopUp from '../ShowModalPopUp';
import _ from 'lodash';
import Picky from 'react-picky';
// import {Tabs, Tab} from 'react-bootstrap';
import 'react-picky/dist/picky.css'; // Include CSS

export default class WebFormCreate extends Component {
  constructor(props){
    super(props)
    this.state={
      selectedTemplate:[],
      selectedregionName:[],
      selectedcenterName:[], 
      selectedclientName:[], 
      selectedprocessName:[],
      viewForm:false
    }
  }
  componentWillMount(){
    
  }
  UNSAFE_componentWillReceiveProps(nextProps){
    if(!_.isEmpty(nextProps.reports)){
      this.setState({reports:nextProps.reports})
    }
  }
  handleSelectTemplate = (e) => {
    const{selectedTemplate} = this.state;
    this.setState({selectedTemplate: e});
    if(!_.isEqual(selectedTemplate, e)){
      this.setState({viewForm:false})
    }
  }
  viewTemplate = () => {
    if(!_.isEmpty(this.state.selectedTemplate)){
      this.setState({viewForm:true})
      let userName = this.props.loginAction.userName
      this.props.function.TokenValidation() 
      let data = {
        'region':this.state.selectedregionName.inventoryRegionId,
        'regionName':this.state.selectedregionName.inventoryRegionName,
        'center':this.state.selectedcenterName.inventoryCenterId,
        'centerName':this.state.selectedcenterName.inventoryCenterName,
        'client':this.state.selectedclientName.inventoryClientId,
        'clientName':this.state.selectedclientName.inventoryClientName,
        'process':this.state.selectedprocessName.inventoryProcessId,
        'processName':this.state.selectedprocessName.inventoryProcessName,
        'formId':this.state.selectedTemplate.webformid,
        'userName':userName        
      }    
      this.props.function.viewReport(data)
    }
  }
  handleChange = (e, index) =>{
    const{reports} = this.state
    let obj = reports.objects[index]
    obj['value'] =  e.target.value
    this.setState({reports:reports})
  }
  handleSave = () => {
    this.props.function.TokenValidation()  
    let userName = this.props.loginAction.userName
    let data = {
      'region':this.state.selectedregionName.inventoryRegionId,
      'regionName':this.state.selectedregionName.inventoryRegionName,
      'center':this.state.selectedcenterName.inventoryCenterId,
      'centerName':this.state.selectedcenterName.inventoryCenterName,
      'client':this.state.selectedclientName.inventoryClientId,
      'clientName':this.state.selectedclientName.inventoryClientName,
      'process':this.state.selectedprocessName.inventoryProcessId,
      'processName':this.state.selectedprocessName.inventoryProcessName,
      'formId':this.state.selectedTemplate.webformid,
      'title':this.state.selectedTemplate.title        
    }
    let obj = {...this.state.reports, ...data, userName}
    this.props.function.viewReportSubmit(obj)
    this.setState({selectedTemplate:[], viewForm:false, reports:[],
      selectedregionName:[], selectedcenterName:[], selectedclientName:[], selectedprocessName:[]})
  }
  
  regionNames = () => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
     let regionNames = _.filter(inventory);
      return regionNames;
    }    
  }
  centerNames = () => {
    const{selectedregionName} = this.state;
    if(!_.isEmpty(selectedregionName)){
      let centerName = selectedregionName.userCenters
      return centerName;
    }
    
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    let clientName = []
    if(!_.isEmpty(selectedcenterName)){
        clientName = _.filter(selectedcenterName.userClients);
        clientName = _.uniqBy(clientName, 'inventoryClientId');
    }
    return clientName;
  }
  processNames = () => {
    const{selectedclientName} = this.state;
    let processName=[];
    if(!_.isEmpty(selectedclientName)){
            processName = (selectedclientName.userProcesses)
            processName = _.uniqBy(processName, 'inventoryProcessId');
      }
    return processName;
  }  
  handleSelect = (e) => {
    this.setState({selectedregionName: e});
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[], selectedTemplate:[], viewForm:false})
      
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      
      this.setState({selectedclientName:[], selectedprocessName:[], selectedTemplate:[], viewForm:false})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      
      this.setState({selectedprocessName:[], selectedTemplate:[], viewForm:false})
    }
  }
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});  
    let data = {
      'region':this.state.selectedregionName.inventoryRegionId,
      'center':this.state.selectedcenterName.inventoryCenterId,
      'client':this.state.selectedclientName.inventoryClientId,
      'process':e.inventoryProcessId 
    }
    
    this.props.function.formNamesMapped(data)
    if(!_.isEqual(this.state.selectedprocessName, e)){
      this.setState({selectedTemplate:[], viewForm:false})
    }
  }
  render(){ 
    const{webFormNames, reports} = this.props;
    let UI
    if(!_.isEmpty(reports)){
      UI = _.map(reports.objects, (val, index) =>{
      return( 
      <tr>
        <td>{val.label}</td>
        <td><input type='text' className='fullWidth' value={val.value ? val.value : ""}
        onChange={(e)=>this.handleChange(e, index)}/></td>
      </tr>
      )      
     })
   } else {
     UI = <tr><td colSpan='2'>No Records Found</td></tr>
   }
   let n = UI.length
   let firstObj = UI
   let secondObj =[]
   if(n>=10){
   firstObj = _.slice(UI, 0, n/2+1)
   secondObj = _.slice(UI, n/2+1, n) }
    return(
      <div style={{'minHeight':'300px', 'overflow-x':'hidden'}}>
       <Row className='marginBottom'>
         <Col><label><b>REGION NAME<span className="RedColoring"> *</span></b></label><br/>
          <Picky keepOpen={false}
          value={this.state.selectedregionName}
          options={this.regionNames()}
          onChange={this.handleSelect}
          open={false}
          valueKey="inventoryRegionName"
          labelKey="inventoryRegionName"
          multiple={false}
          includeSelectAll={false}
          includeFilter={false}
          placeholder='Select Region'
          dropdownHeight={600}
          /></Col>
          <Col><label><b>CENTER NAME<span className="RedColoring"> *</span></b></label>
          <Picky keepOpen={false}
          value={this.state.selectedcenterName}
          options={this.centerNames()}
          onChange={this.handleSelectCenter}
          open={false}
          valueKey="inventoryCenterName"
          labelKey="inventoryCenterName"
          multiple={false}
          includeSelectAll={true}
          includeFilter={false}
          placeholder='Select Center'
          dropdownHeight={600}
          /></Col>
          <Col><label><b>CLIENT NAME<span className="RedColoring"> *</span></b></label>
          <Picky keepOpen={false}
          value={this.state.selectedclientName}
          options={this.clientNames()}
          onChange={this.handleSelectClient}
          open={false}
          valueKey="inventoryClientName"
          labelKey="inventoryClientName"
          multiple={false}
          includeSelectAll={true}
          includeFilter={false}
          placeholder='Select Client'
          dropdownHeight={600}
          /></Col>
          <Col> 
            <label><b>PROCESS NAME<span className="RedColoring"> *</span></b></label>
            <Picky keepOpen={false}
            value={this.state.selectedprocessName}
            options={this.processNames()}
            onChange={this.handleSelectProcess}
            open={false}
            valueKey="inventoryProcessName"
            labelKey="inventoryProcessName"
            multiple={false}
            includeSelectAll={true}
            includeFilter={false}
            placeholder='Select Process'
            dropdownHeight={600}
          /></Col>
        <Col>
        <label><b>WEB FORM<span className="RedColoring"> *</span></b></label>
          <Picky keepOpen={false}
            value={this.state.selectedTemplate}
            options={(!_.isEmpty(webFormNames)) ? [webFormNames] :[]}
            onChange={this.handleSelectTemplate}
            open={false}
            valueKey="title"
            labelKey="title"
            multiple={false}
            includeSelectAll={false}
            includeFilter={false}
            placeholder='Select Web Form'
            dropdownHeight={600}
          />
        </Col>
        <Col>{ (this.state.viewForm  && !_.isEmpty(reports)) ?
        
        <Button style={{marginTop:'25px'}} className='buttonwidth'  onClick={this.handleSave}>Submit</Button> : 
        <Button style={{marginTop:'25px'}} className='buttonwidth' disabled={_.isEmpty(this.state.selectedTemplate)}  onClick={this.viewTemplate}>View</Button>}</Col>
      </Row>
      { (this.state.viewForm)?
        <Row>
          <Col md={1}></Col>
          <Col> 
          <Table responsive>
          <thead><tr><th>FIELD NAME</th><th>VALUE</th></tr></thead>
          <tbody>
            {firstObj}
          </tbody>
          </Table>
          </Col>
          <Col>
          {(n>=10) ?
           <Table responsive>
           <thead><tr><th>FIELD NAME</th><th>VALUE</th></tr></thead>
           <tbody>
             {secondObj}
           </tbody>
         </Table> : null}</Col>          
        </Row> 
        : null
      } 
      </div>)
  }
}

